import React, { useEffect, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import axios from "axios";
import SideBar from "../SideBar";
import { baseUrl } from "../../../baseUrl";
import { useAuth } from "../../../AuthContext";
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import api from "../../../api";
import {toast} from "react-toastify"

const CreateTopic = () => {
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();

  const [topicName, setTopicName] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setMessage(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, [message]);

  const handleSubmit = () => {
    if (topicName === "" || subject === "") {
      setMessage("Please enter all details");
      return;
    }

    setProcessing(true);

    api
      .post(`${baseUrl}/topic/create`, { topicName, subject })
      .then((res) => {
        setMessage(res.data);
        setTopicName("");
        setSubject("");
        setProcessing(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "something went wrong")
        setProcessing(false);
      });
  };

  return (
    <div className={`${styles.layout} ${isSidebarOpen ? "" : `${styles.sidebarClosed}`}`}>
      <aside className={`${styles.sidebar} ${isSidebarOpen ? styles.open : styles.closed}`}>
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
        <div style={{ height: "30px" }} className="position-relative">
          {isSidebarOpen ? (
            <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />
          ) : (
            <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />
          )}
        </div>

        {/* Breadcrumb */}
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <div className="d-flex flex-grow-1">
              <li className="breadcrumb-item">
                <Link to="/admin/dashboard" className="text-decoration-none">
                  Dashboard
                </Link>
              </li>
              <li className="breadcrumb-item active">Create Topic</li>
            </div>

            <li className="nav-item dropdown">
              <span className="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                Welcome, {user.name}
              </span>
              <ul className="dropdown-menu">
                <li>
                  <span className="dropdown-item" onClick={logout}>
                    Logout
                  </span>
                </li>
              </ul>
            </li>
          </ol>
        </nav>

        <div className={`container ${styles.container}`}>
          <div className="bg-white p-4">
            <h4>Create Topic</h4>

            {/* Topic Name */}
            <div className="row mb-3">
              <div className="col-lg-6">
                <label className="form-label">Topic Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter topic name"
                  value={topicName}
                  onChange={(e) => setTopicName(e.target.value)}
                />
              </div>
            </div>

            {/* Subject */}
            <div className="row mb-3">
              <div className="col-lg-6">
                <label className="form-label">Subject</label>
                <select
                  className="form-select"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                >
                  <option value="" hidden>Select Subject</option>
                  <option>Physics</option>
                  <option>Chemistry</option>
                  <option>Biology</option>
                </select>
              </div>
            </div>

            {/* Message */}
            {message && (
              <div className="alert alert-warning mt-3">
                {message}
              </div>
            )}

            {/* Submit */}
            <button
              disabled={processing}
              onClick={handleSubmit}
              className="btn btn-primary mt-3"
            >
              {processing ? "Loading..." : "Create Topic"}
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CreateTopic;